/**
 * Shared validation utilities for the Machinery Movers platform.
 */

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Check if a string is a valid UUID v4 format.
 */
export function isValidUUID(value: string): boolean {
  return UUID_REGEX.test(value);
}

/**
 * Validate a UUID and throw a descriptive error if invalid.
 * @param value - The string to validate
 * @param fieldName - Human-readable field name for error message
 */
export function validateUUID(value: string | undefined | null, fieldName: string): void {
  if (!value || !isValidUUID(value)) {
    throw new Error(`Invalid ${fieldName}. Please ensure you are using a valid ID.`);
  }
}
